import CampusConsultorioDashboard from "./campus-consultorio";

export default function ConsultorioDashboard() {
  return <CampusConsultorioDashboard moduleFocus="consultorio" />;
}

